import { formatNpub } from '@/lib/pubkey'
import { CheckIcon, Copy01Icon } from '@hugeicons/core-free-icons'
import { HugeiconsIcon } from '@hugeicons/react'
import { useState } from 'react'

export function NpubCopy({ npub }: { npub: string }) {
  const [copied, setCopied] = useState(false)

  return (
    <div
      className="flex gap-2 text-sm text-muted-foreground items-center bg-muted w-fit px-2 rounded-full cursor-pointer transition-colors hover:bg-muted/30 active:bg-muted/30"
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        copyNpub()
      }}
    >
      <ShortNpub npub={npub} />
      {copied ? (
        <HugeiconsIcon icon={CheckIcon} size={14} />
      ) : (
        <HugeiconsIcon icon={Copy01Icon} size={14} />
      )}
    </div>
  )

  function copyNpub() {
    navigator.clipboard.writeText(npub)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }
}

function ShortNpub({ npub }: { npub: string }) {
  return (
    <span
      onCopy={(e) => {
        e.preventDefault()
        e.stopPropagation()
        e.clipboardData?.setData('text/plain', npub)
      }}
      className={`rounded px-1 py-0.5 transition-colors`}
    >
      {/* Real value: present for selection/copy, visually collapsed */}
      <span className="absolute w-px h-px overflow-hidden whitespace-nowrap [clip:rect(0,0,0,0)]">
        {npub}
      </span>
      {/* fake/display value: what the user sees, not selectable, ignored by a11y */}
      <span aria-hidden="true">{formatNpub(npub)}</span>
    </span>
  )
}
